export interface GetCompanyParams {
  legacyAccountCode?: string;
  name?: string;
  productId?: string;
  locationId?: string;
  q?: string;
  df?: string;
  sort?: string;
  page?: number;
  per_page?: number;
}

export interface GetCompanyDivisionsParams {
  name?: string;
  type?: string;
  legacyAccountCode?: string;
  divisionIds?: string[];
  q?: string;
  df?: string;
  default_operator?: string;
  sort?: string;
  page?: number;
  per_page?: number;
  status?: string;
  // company_id: string; required parameter but part of URL only
}

export interface GetDotNumberParams {
  divisionId?: string;
  dotNumber?: string;
  q?: string;
  df?: string;
  default_operator?: string;
  sort?: string;
  page?: number;
  per_page?: number;
  // company_id: string; required as part of URL only.
}

export interface GetAssetsParams {
  // companyId: string; included in URL only
  // divisionId: string; ditto
  assetType?: string;
  allChildren?: boolean;
  page?: number;
  per_page?: number;
  q?: string;
  df?: string;
  default_operator?: string;
  sort?: string;
  filterFields?: string[];
}

export interface CreateCompanyParams {
  name: string;
  anonymizedData: boolean;
}

export interface CreateCompanyResult extends CreateCompanyParams {
  id: string;
  created: Date;
  modified: Date;
  defaultDivisionId?: string;
}

export interface Company {
  id: string;
  name: string;
  anonymizedData: boolean;
  created: Date;
  modified: Date;
  defaultDivisionId: string;
}

export interface Division {
  id: string;
  status: string;
  name: string;
  type: string;
  locationId: string;
  companyId: string;
  parentId: string;
  children: string[];
  legacyAccountCode: string;
  assetCount: number;
  legacyLocationsForLimitedUser?: { id: string; name: string }[];
}

export interface Address {
  street: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  county: string;
}

export interface Position {
  lat: number;
  lon: number;
}

export interface Location {
  id: string;
  name: string;
  address: Address;
  timezone?: string;
  position: Position;
}

export interface Asset {
  id: string;
  name: string;
  ownerName: string;
  companyId: string;
  divisions: string[];
  assetType: string;
  assetVersion: string;
}

export interface CompanyDataSearchParams {
  page?: number;
  per_page?: number;
  q?: string;
  sort?: string;
  divisionIds?: string[];
  status?: string;
}

export enum Permissions {
  CREATE_COMPANY = 'create:company',
  READ_COMPANY = 'read:company',
  READ_COMPANIES = 'read:companies',
  UPDATE_COMPANY = 'update:company',
  ASSOCIATE_COMPANY = 'associate:company',
  DEASSOCIATE_COMPANY = 'deassociate:company'
}

export enum DivisionStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export interface CreateDivisionParams {
  status: DivisionStatus;
  name: string;
  type: string;
  locationId?: string;
  parentId?: string;
  legacyAccountCode?: string;
}

export interface CreateDivisionResult extends CreateDivisionParams {
  id: string;
  companyId?: string;
  children?: string[];
}

export interface GetDivisionParams {
  legacyAccountCode?: string;
}

export interface Role {
  id: string;
  name: string;
  description: string;
  restricted: string;
  productId: string;
  permissions: string[];
  type: string;
}

export interface Application {
  id: string;
  name: string;
  type: string;
  description: string;
  identityProviderId: string;
  allowManagedUsers: string;
  products: string[];
  permissions: string[];
  roles: Role[];
}

//--------------------- vdo models ---------------------//

export interface CustomListElement {
  id: number;
  description: string;
  name: string;
  siteId?: string;
  // state?: ProgressState;
  connectionStatus?: string;
  workingTimeLegislation?: string;
  country?: string;
}

export interface CustomListData {
  data: CustomListElement[];
  totalNumberOfElements: number;
}

export interface CustomListFilter {
  [key: string]: any;
  sort?: string;
  sortDirection?: string;
  search?: string;
  page?: number;
  size?: number;
  // advancedFilters?: AdvancedFilters;
  siteId?: string;
  groupId?: string;
  multiSiteIds?: string;
  useTimePeriod?: boolean;
  from?: string;
  to?: string;
  groupName?: string;
  siteName?: string;
}

export interface SimpleVehicle {
  id: number;
  siteId: string;
  vrn: string;
  displayName: string;
}

export interface VehicleList {
  data: VehicleListItem[];
  numberOfElementsPerPage: number;
  numberOfElementsMatchingQuery: number;
  page: number;
  totalNumberOfElements: number;
  totalNumberOfPages: number;
}

export interface VehicleListItem {
  id: number;
  label?: string;
  vrn: string;
  vin?: string;
  lastDataRecordedOn: string; // ISO date
  siteId?: string;
  status: any;
  state: any;
  displayName: string;

  // [key: string]: any;
}

export interface DriverCard {
  id: number;
  active: boolean;
  cardNumber: string;
  firstName: string;
  lastName: string;
  driverCardId: string;
  issuingState: string;
  issuingAuthority: string;
  cardIssueDate: string;
  cardValidityBegin: string;
  cardExpiryDate: string;
  siteId: string;
  startDate: Date;
  // rfId: RfId;
}

export interface DriverDetailsDto {
  id: number;
  siteId: string;
  siteName: string;
  siteAccountId: number;
  //siteTemplateId: number;
  title: string;
  firstName: string;
  lastName: string;
  //phoneNumber: string;
  //email: string;
  referenceNumber: string;
  driverCards: DriverCard[];
  // driverContracts: DriverContract[];
  // driverLicense: DriverLicense | null;
  //startDate: string;
  //finishDate: string;
  //noFinishDate: boolean;
  //birthDate: string;
  //noBirthDate: boolean;
  //nightWorker: boolean;
  // gender: DriverGender;
  preferredLanguage: string;
  displayName: string;
  //trainingCompleted: boolean;
  //nextTrainingDate: string | null;
  street: string;
  postalCode: string;
  location: string;
  country: string;
  //driverBaseLocation: boolean;
  //latitude: number;
  //longitude: number;
  //radius: number;
  //driverServiceType: boolean;
  // [key: string]: any;
}

export interface DriverList {
  data: DriverDetailsDto[];
  numberOfElementsPerPage: number;
  numberOfElementsMatchingQuery: number;
  page: number;
  totalNumberOfElements: number;
  totalNumberOfPages: number;
}
